<template>
  <div class="addevent eventdata addeventclass">
    <EventInfo
      client_name="DY"
      field_name="class"
      event_type="class"
      action="create"
      :locations="locations"
    />
  </div>
</template>

<script>
import EventInfo from "@/components/events/EventInfo.vue";
import EventPayment from "@/components/events/Payment.vue";
import EventLocation from "@/components/events/Location.vue";
import mDatePicker from "@/components/multi-date-picker/multiDatePicker.vue";
import $ from "jquery";
import axios from "axios";
import moment from "moment";

export default {
  name: "EventClass",
  components: { EventLocation, EventPayment, mDatePicker, EventInfo },
  data() {
    return {
      
      locations: [
        { text: "ZOOM ONLINE", id: "ZOOM ONLINE" },
        { text: "Kimberley Street, London", id: "Kimberley Street, London" },
        { text: "Dublin, Ireland", id: "Dublin, Ireland" },
        { text: "Studio Doom Yoga, London", id: "Studio Doom Yoga, London" },
      ],
    };
  },
  methods: {
  }
};
</script>
<style >
.imgFromGroup > div {
  height: calc(100% - 35px);
  max-height: calc(100% - 35px);
}
</style>


// WEBPACK FOOTER //
// src/components/doom_yoga/events/AddClass.vue